module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/YcIaEm/images/cover.jpg?1685790544048",
      "alt": "This image is the cover for the book Paul and the Language of Faith"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Paul and the Language of Faith\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A dynamic reading of Paul’s faith language, outlining its subtle nuances as belief, trust, and faithfulness.")]), _c('p', [_vm._v("Faith language permeates the letters of Paul. Yet, its exact meaning is not always clear. Many today, reflecting centuries of interpretation, consider belief in Jesus to be a passive act. In this important book, Nijay Gupta challenges common assumptions in the interpretation of Paul and calls for a reexamination of Paul’s faith language. Gupta argues that Paul’s faith language resonates with a Jewish understanding of covenant involving goodwill, trust, and expectation. Paul’s understanding of faith involves the transformation of one’s perception of God and the world through Christ, relational dependence on Christ, as well as active loyalty to Christ. ")]), _vm._v(" Pastors and scholars alike will benefit from this close examination of Paul’s understanding and use of faith language. For Gupta, Paul’s understanding involves a divine-human relationship centered on Christ that believes, trusts, and obeys.\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nijay K. Gupta, James D. G. Dunn\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0